// @owners { team: patients }
import { getBrand } from '@alto/design-system';
export type CompanyName = 'Alto' | 'Fuze Health';

/**
 * Get the company display name based on the current brand.
 * @returns CompanyName ('Alto' or 'Fuze Health')
 */
export const getCompanyName = (): CompanyName => {
  const brand = getBrand();

  if (brand === 'fuzehealth') {
    return 'Fuze Health';
  }

  if (brand === 'alto') {
    return 'Alto';
  }

  throw new Error('Unknown brand');
};
